// extracted by mini-css-extract-plugin
export default {"nav":"layout_nav__Nk76l","navli":"layout_navli__nXOam","footer":"layout_footer__3TcS1"};